import { useEffect } from 'react';
import { getPixConfig } from '../lib/financeiroStorage';

const MESSAGE_TYPE = 'naviex-financeiro-pix-export';

/**
 * Página pública (sem login) usada pelo cliente para obter a configuração PIX
 * quando cliente e admin rodam em origens diferentes.
 * Envia os dados via postMessage para window.parent.
 */
export default function FinanceiroPixExportPage() {
  useEffect(() => {
    try {
      const config = getPixConfig();
      if (window.parent !== window) {
        window.parent.postMessage({ type: MESSAGE_TYPE, pixConfig: config }, '*');
      }
    } catch (err) {
      if (window.parent !== window) {
        window.parent.postMessage({ type: MESSAGE_TYPE, pixConfig: null, error: String(err) }, '*');
      }
    }
  }, []);

  return (
    <div className="p-4 text-sm text-gray-500">
      Configuração PIX enviada ao cliente.
    </div>
  );
}

export { MESSAGE_TYPE };
